module.exports = __webpack_public_path__ + "images/0da1370f64f10fc63b55f8b70856bc2e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/app/scenes/Shell/scenes/Header/img/cpi-logo.jpg
// module id = 1247
// module chunks = 0